import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Calendar Multiselect Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-calendar-multiselect-outline',
    templateUrl: './icon-calendar-multiselect-outline.component.html',
    styleUrls: ['./icon-calendar-multiselect-outline.component.scss'],
    standalone: false
})
export class IconCalendarMultiselectOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
